import { SVGProps } from 'react';
import Icon from '../../Icon';

/** Fills its wrapper (LineRoundedWrapper sets the size); `stroke` sets the colour. */
const LineRoundedSearch = ({ stroke, color }: SVGProps<SVGElement>) => (
  <Icon name="search" size="100%" color={stroke ?? color} />
);

export { LineRoundedSearch };
